import { render, staticRenderFns } from "./index.vue?vue&type=template&id=405a7665&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=405a7665&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a7665",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('405a7665')) {
      api.createRecord('405a7665', component.options)
    } else {
      api.reload('405a7665', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=405a7665&scoped=true", function () {
      api.rerender('405a7665', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shoppingGift/accountDetails/index.vue"
export default component.exports